import React from 'react';
import relaxImg from '../img/relaxImg.png';
import decorImg from '../img/decorImg.png';
import safeImg from '../img/safe.jpg';
import giftImg from '../img/giftImg.jpg';

const Benefits = () => {
  const items = [
    { img: relaxImg, title: "Thư giãn sâu", desc: "Giúp bạn giảm căng thẳng, dễ ngủ hơn." },
    { img: decorImg, title: "Trang trí tinh tế", desc: "Tăng tính thẩm mỹ cho không gian sống." },
    { img: safeImg, title: "An toàn tự nhiên", desc: "Tinh dầu nguyên chất, thân thiện sức khỏe." },
    { img: giftImg, title: "Quà tặng ý nghĩa", desc: "Một món quà đầy tinh tế và ấm áp." },
  ];

  return (
    <section id="benefits" className="section benefits">
      <h2 className="section-title">Lợi Ích Sản Phẩm</h2>
      <div className="benefits-grid">
        {items.map((item, index) => (
          <div key={index} className="benefit-card">
            <div className="benefit-image">
              <img src={item.img} alt={item.title} />
            </div>
            <h3 className="benefit-title">{item.title}</h3>
            <p className="benefit-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefits;
